import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IPoi} from "../types/IPoi";
import {IPublicTransportRoute} from "../types/IPublicTransportRoute";
import {IPublicTransportType} from "../types/IPublicTransportType";
import {PoiType, TransportPoiType} from "../types/PoiType";

type AmplitudePoiType = "metro" | "bus" | "tram" | "train";

export interface ITrackAmplitudePoiClickParams {
    location: "investment_page" | "property_page";
    route: IPublicTransportRoute;
    itemId: number;
    propertyId: number | null;
}

interface ITrackAmplitudeMapPoiClickParams {
    location: "investment_page" | "property_page";
    poi: Pick<IPoi, "name">;
    poiType: PoiType;
    poiSubType?: TransportPoiType;
    itemId: number;
    propertyId: number | null;
}

const amplitudePoiTypeByPublicTransportType: Record<IPublicTransportType, AmplitudePoiType> = {
    [IPublicTransportType.SUBWAY]: "metro",
    [IPublicTransportType.BUS]: "bus",
    [IPublicTransportType.TRAM]: "tram",
    [IPublicTransportType.TRAIN]: "train"
};

const amplitudePoiTypeByTransportPoiType: Record<TransportPoiType, AmplitudePoiType> = {
    [TransportPoiType.SUBWAY]: "metro",
    [TransportPoiType.BUS]: "bus",
    [TransportPoiType.TRAM]: "tram",
    [TransportPoiType.RAILWAY]: "train"
};

export const trackAmplitudePoiClick = ({location, route, itemId, propertyId}: ITrackAmplitudePoiClickParams): void => {
    trackAmplitudeEvent("poi_click", {
        location,
        poi_id: route.name,
        poi_type: amplitudePoiTypeByPublicTransportType[route.type],
        item_id: itemId,
        property_id: propertyId
    });
};

export const trackAmplitudeMapPoiClick = ({location, poi, poiType, poiSubType, itemId, propertyId}: ITrackAmplitudeMapPoiClickParams): void => {
    const amplitudePoiType = poiType === PoiType.TRANSPORT && poiSubType ? amplitudePoiTypeByTransportPoiType[poiSubType] : poiType;

    trackAmplitudeEvent("poi_click", {
        location,
        poi_id: poi.name,
        poi_type: amplitudePoiType,
        item_id: itemId,
        property_id: propertyId
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IPoi} from "../types/IPoi";
import {IPublicTransportRoute} from "../types/IPublicTransportRoute";
import {IPublicTransportType} from "../types/IPublicTransportType";
import {PoiType, TransportPoiType} from "../types/PoiType";

type AmplitudePoiType = "metro" | "bus" | "tram" | "train";

export interface ITrackAmplitudePoiClickParams {
    location: "investment_page" | "property_page";
    route: IPublicTransportRoute;
    itemId: number;
    propertyId: number | null;
}

interface ITrackAmplitudeMapPoiClickParams {
    location: "investment_page" | "property_page";
    poi: Pick<IPoi, "name">;
    poiType: PoiType;
    poiSubType?: TransportPoiType;
    itemId: number;
    propertyId: number | null;
}

const amplitudePoiTypeByPublicTransportType: Record<IPublicTransportType, AmplitudePoiType> = {
    [IPublicTransportType.SUBWAY]: "metro",
    [IPublicTransportType.BUS]: "bus",
    [IPublicTransportType.TRAM]: "tram",
    [IPublicTransportType.TRAIN]: "train"
};

const amplitudePoiTypeByTransportPoiType: Record<TransportPoiType, AmplitudePoiType> = {
    [TransportPoiType.SUBWAY]: "metro",
    [TransportPoiType.BUS]: "bus",
    [TransportPoiType.TRAM]: "tram",
    [TransportPoiType.RAILWAY]: "train"
};

export const trackAmplitudePoiClick = ({location, route, itemId, propertyId}: ITrackAmplitudePoiClickParams): void => {
    trackAmplitudeEvent("poi_click", {
        location,
        poi_id: route.name,
        poi_type: amplitudePoiTypeByPublicTransportType[route.type],
        item_id: itemId,
        property_id: propertyId
    });
};

export const trackAmplitudeMapPoiClick = ({location, poi, poiType, poiSubType, itemId, propertyId}: ITrackAmplitudeMapPoiClickParams): void => {
    const amplitudePoiType = poiType === PoiType.TRANSPORT && poiSubType ? amplitudePoiTypeByTransportPoiType[poiSubType] : poiType;

    trackAmplitudeEvent("poi_click", {
        location,
        poi_id: poi.name,
        poi_type: amplitudePoiType,
        item_id: itemId,
        property_id: propertyId
    });
};
